import { render, staticRenderFns } from "./UploadImages.vue?vue&type=template&id=06b53493&lang=pug&"
import script from "./UploadImages.vue?vue&type=script&lang=js&"
export * from "./UploadImages.vue?vue&type=script&lang=js&"
import style0 from "./UploadImages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UploadImages.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports